package editor.keyboard

import kotlinx.browser.window
import org.w3c.dom.events.KeyboardEvent

object KeyboardManager {
    var ctrlPressed = false; private set
    var altPressed = false; private set
    var shiftPressed = false; private set

    init {
        window.addEventListener("keydown", {
            if (it !is KeyboardEvent) return@addEventListener

            ctrlPressed = it.ctrlKey
            altPressed = it.altKey
            shiftPressed = it.shiftKey
        })

        window.addEventListener("keyup", {
            if (it !is KeyboardEvent) return@addEventListener

            ctrlPressed = it.ctrlKey
            altPressed = it.altKey
            shiftPressed = it.shiftKey
        })
    }
}